import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
 
 
let routes= [
  // {
  //   path: '/',
  //   name: 'defautlogin',
  //   //使用import可以路由懒加载，如果不使用，太多组件一起加载会造成白屏
  //   component: () => import('../views/Login.vue')
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/printedit',
    name: 'printedit',
    component: () => import('../views/PrintEdit.vue')
  },
  {
    path: '/picklabel',
    name: 'picklabel',
    component: () => import('../views/Picklabel.vue')
  },
  {
    path: '/printpage',
    name: 'printpage',
    component: () => import('../views/PrintPage.vue')
  },
  {
    path: '/homefull/',
    name: 'fullmain',
    component: () => import('../views/homefull/FullMain.vue'),
    children: [
      {
        path: 'datafull',
        name: 'datafull',
        component: () => import('../views/homefull/DataFull.vue')
      },
      {
        path: 'sortfull',
        name: 'sortfull',
        component: () => import('../views/homefull/SortFull.vue')
      },
      {
        path: 'deliveryfull',
        name: 'deliveryfull',
        component: () => import('../views/homefull/DeliveryFull.vue')
      },
      {
        path: 'carfull',
        name: 'carfull',
        component: () => import('../views/homefull/Carfull.vue')
      },
      {
        path: 'sourcefull',
        name: 'sourcefull',
        component: () => import('../views/homefull/SourceFull.vue')
      },
    ]
  },
  {
    path: '/homefullHm/',
    name: 'fullmainHm',
    component: () => import('../views/homefullHm/FullMain.vue'),
    children: [
      {
        path: 'datafullHm',
        name: 'datafullHm',
        component: () => import('../views/homefullHm/DataFull.vue')
      },
      {
        path: 'sortfullHm',
        name: 'sortfullHm',
        component: () => import('../views/homefullHm/SortFull.vue')
      },
      {
        path: 'deliveryfullHm',
        name: 'deliveryfullHm',
        component: () => import('../views/homefullHm/DeliveryFull.vue')
      },
      {
        path: 'sourcefullHm',
        name: 'sourcefullHm',
        component: () => import('../views/homefullHm/SourceFull.vue')
      },
    ]
  },
  {
    path: '/',
    name: 'mainpage',
    component: () => import('../views/Mainpage.vue'),
    children: [
      // {
      //   path: '',
      //   name: 'redirect',
      //   redirect: '/login',
      //   // component: () => import('../views/Home.vue'),
      // },
      // {
      //   path: 'home',
      //   name: 'home',
      //   component: () => import('../views/Home.vue'),
      // },
      {
        path: '',
        name: 'home',
        component: () => import('../views/Home.vue'),
      },
      {
        path: 'goods/management/quotationmanage',
        name: 'quotationmanage',
        component: () => import('../views/goods/management/QuotationManage.vue')
      },
      {
        path: 'goods/management/quotationsupplier',
        name: 'quotationsupplier',
        component: () => import('../views/goods/management/QuotationSupplier.vue')
      },
      {
        path: 'goods/management/cycleprice',
        name: 'cycleprice',
        component: () => import('../views/goods/management/CyclePrice.vue')
      },
      {
        path: 'goods/management/warehouse',
        name: 'warehouse',
        component: () => import('../views/goods/management/WareHouse.vue')
      },
      {
        path: 'goods/management/goodslist',
        name: 'goodslist',
        component: () => import('../views/goods/management/GoodsList.vue')
      },
      {
        path: 'goods/management/goodsspec',
        name: 'goodsspec',
        component: () => import('../views/goods/management/GoodsSpec.vue')
      },
      {
        path: 'goods/management/goodsinventoryset',
        name: 'goodsinventoryset',
        component: () => import('../views/goods/management/GoodsInventorySet.vue')
      },
       {
        path: 'goods/management/goodslossset',
        name: 'goodslossset',
        component: () => import('../views/goods/management/GoodsLossSet.vue')
      },
      {
        path: 'goods/management/goodsinspectionset',
        name: 'goodsinspectionset',
        component: () => import('../views/goods/management/GoodsInspectionSet.vue')
      },
      {
        path: 'goods/management/customergoods',
        name: 'customergoods',
        component: () => import('../views/goods/management/CustomerGoods.vue')
      },
      {
        path: 'goods/management/dcpro',
        name: 'dcpro',
        component: () => import('../views/goods/management/Dcpro.vue')
      },
      {
        path: 'goods/management/goodsunit',
        name: 'goodsunit',
        component: () => import('../views/goods/management/GoodsUnit.vue')
      },
      {
        path: 'goods/management/sortmanage',
        name: 'sortmanage',
        component: () => import('../views/goods/management/SortManage.vue')
      },
      {
        path: 'goods/management/goodsremark',
        name: 'goodsremark',
        component: () => import('../views/goods/management/GoodsRemark.vue')
      },
      {
        path: 'goods/management/newdemand',
        name: 'newdemand',
        component: () => import('../views/goods/management/NewDemand.vue')
      },
      {
        path: 'goods/management/supplierproducer',
        name: 'supplierproducer',
        component: () => import('../views/goods/management/SupplierProducer.vue')
      },
      {
        path: 'goods/management/commissionrule',
        name: 'commissionrule',
        component: () => import('../views/goods/management/CommissionRule.vue')
      },
      {
        path: 'goods/management/offerrecord',
        name: 'offerrecord',
        component: () => import('../views/goods/management/OfferRecord.vue')
      },
      {
        path: 'goods/management/hmcat',
        name: 'hmcat',
        component: () => import('../views/goods/management/Hmcat.vue')
      },
      {
        path: 'goods/management/hmgoods',
        name: 'hmgoods',
        component: () => import('../views/goods/management/Hmgoods.vue')
      },
      {
        path: 'goods/contractprice/discountprice',
        name: 'discountprice',
        component: () => import('../views/goods/contractprice/DiscountPrice.vue')
      },
      {
        path: 'goods/contractprice/upprice',
        name: 'upprice',
        component: () => import('../views/goods/contractprice/UpPrice.vue')
      },
      {
        path: 'buzvision/goodsnorm',
        name: 'goodsnorm',
        component: () => import('../views/buzvision/GoodsNorm.vue')
      },
      {
        path: 'order/orderlist',
        name: 'orderlist',
        component: () => import('../views/order/OrderList.vue')
      },
      {
        path: 'order/draftorder',
        name: 'draftorder',
        component: () => import('../views/order/DraftOrder.vue')
      },
      {
        path: 'order/orderpro',
        name: 'orderpro',
        component: () => import('../views/order/Orderpro.vue')
      },
      {
        path: 'order/createorder',
        name: 'createorder',
        component: () => import('../views/order/CreateOrder.vue')
      },
      {
        path: 'order/combineorder',
        name: 'combineorder',
        component: () => import('../views/order/CombineOrder.vue')
      },
      {
        path: 'order/goodsdepo',
        name: 'goodsdepo',
        component: () => import('../views/order/GoodsDepo.vue')
      },
      {
        path: 'order/orderdiff',
        name: 'orderdiff',
        component: () => import('../views/order/Orderdiff.vue')
      },
      {
        path: 'order/realdiff',
        name: 'realdiff',
        component: () => import('../views/order/Realdiff.vue')
      },
      {
        path: 'order/changeordercheck',
        name: 'changeordercheck',
        component: () => import('../views/order/ChangeorderCheck.vue')
      },
      {
        path: 'order/cusfields',
        name: 'cusfields',
        component: () => import('../views/order/CusFields.vue')
      },
      {
        path: 'order/unorderbuyer',
        name: 'unorderbuyer',
        component: () => import('../views/order/UnorderBuyer.vue')
      },
      {
        path: 'order/ordermanage',
        name: 'ordermanage',
        component: () => import('../views/order/OrderManage.vue')
      },
      {
        path: 'order/stockmanage',
        name: 'stockmanage',
        component: () => import('../views/order/StockManage.vue')
      },
      {
        path: 'data/cockpit/salecockpit',
        name: 'salecockpit',
        component: () => import('../views/data/cockpit/SaleCockpit.vue')
      },
      {
        path: 'supplychain/purchase/purchasetask',
        name: 'purchasetask',
        component: () => import('../views/supplychain/purchase/PurchaseTask.vue')
      },
      {
        path: 'supplychain/purchase/purchasebill',
        name: 'purchasebill',
        component: () => import('../views/supplychain/purchase/PurchaseBill.vue')
      },
      {
        path: 'supplychain/purchase/querytask',
        name: 'querytask',
        component: () => import('../views/supplychain/purchase/QueryTask.vue')
      },
      {
        path: 'supplychain/purchase/queryoffer',
        name: 'queryoffer',
        component: () => import('../views/supplychain/purchase/QueryOffer.vue')
      },
      {
        path: 'supplychain/purchase/querylist',
        name: 'querylist',
        component: () => import('../views/supplychain/purchase/QueryList.vue')
      },
      {
        path: 'supplychain/purchase/ledger',
        name: 'ledger',
        component: () => import('../views/supplychain/purchase/Ledger.vue')
      },
      {
        path: 'supplychain/purchase/suggest',
        name: 'suggest',
        component: () => import('../views/supplychain/purchase/Suggest.vue')
      },
      {
        path: 'supplychain/purchase/suggesthb',
        name: 'suggesthb',
        component: () => import('../views/supplychain/purchase/Suggesthb.vue')
      },
      {
        path: 'supplychain/purchase/inspectgoods',
        name: 'inspectgoods',
        component: () => import('../views/supplychain/purchase/InspectGoods.vue')
      },
      {
        path: 'supplychain/purchase/supplierdiscount',
        name: 'supplierdiscount',
        component: () => import('../views/supplychain/purchase/SupplierDiscount.vue')
      },
      {
        path: 'supplychain/purchase/supplierdiscountset',
        name: 'supplierdiscountset',
        component: () => import('../views/supplychain/purchase/SupplierDiscountSet.vue')
      },
      {
        path: 'supplychain/purchase/suppliercashback',
        name: 'suppliercashback',
        component: () => import('../views/supplychain/purchase/SupplierCashback.vue')
      },
      {
        path: 'supplychain/purchase/productissue',
        name: 'productissue',
        component: () => import('../views/supplychain/purchase/ProductIssue.vue')
      },
      {
        path: 'supplychain/purchase/purstrat',
        name: 'purstrat',
        component: () => import('../views/supplychain/purchase/Purstrat.vue')
      },
      {
        path: 'supplychain/purchase/tender',
        name: 'tender',
        component: () => import('../views/supplychain/purchase/Tender.vue')
      },
      {
        path: 'supplychain/purchase/suppliertender',
        name: 'suppliertender',
        component: () => import('../views/supplychain/purchase/SupplierTender.vue')
      },
      {
        path: 'supplychain/purchase/diffmanage',
        name: 'diffmanage',
        component: () => import('../views/supplychain/purchase/DiffManage.vue')
      },
      {
        path: 'supplychain/purchase/editsupplier',
        name: 'editsupplier',
        component: () => import('../views/supplychain/purchase/EditSupplier.vue')
      },
      {
        path: 'supplychain/pick/picktask',
        name: 'picktask',
        component: () => import('../views/supplychain/pick/PickTask.vue')
      },
      {
        path: 'supplychain/pick/stockout',
        name: 'stockout',
        component: () => import('../views/supplychain/pick/Stockout.vue')
      },
      {
        path: 'supplychain/pick/pickbills',
        name: 'pickbills',
        component: () => import('../views/supplychain/pick/PickBills.vue')
      },
      {
        path: 'supplychain/pick/pickdiff',
        name: 'pickdiff',
        component: () => import('../views/supplychain/pick/PickDiff.vue')
      },
      {
        path: 'supplychain/sort/sortprogress',
        name: 'sortprogress',
        component: () => import('../views/supplychain/sort/SortProgress.vue')
      },
      {
        path: 'supplychain/sort/sortdetail',
        name: 'sortdetail',
        component: () => import('../views/supplychain/sort/SortDetail.vue')
      },
      {
        path: 'supplychain/sort/sortdetailnew',
        name: 'sortdetailnew',
        component: () => import('../views/supplychain/sort/SortDetailnew.vue')
      },
      {
        path: 'supplychain/sort/sortdata',
        name: 'sortdata',
        component: () => import('../views/supplychain/sort/SortData.vue')
      },
      {
        path: 'supplychain/sort/sortperform',
        name: 'sortperform',
        component: () => import('../views/supplychain/sort/SortPerform.vue')
      },
      {
        path: 'supplychain/sort/performrule',
        name: 'performrule',
        component: () => import('../views/supplychain/sort/PerformRule.vue')
      },
      {
        path: 'supplychain/delivery/deliverytask',
        name: 'deliverytask',
        component: () => import('../views/supplychain/delivery/DeliveryTask.vue')
      },
      {
        path: 'supplychain/delivery/routecardriver',
        name: 'routecardriver',
        component: () => import('../views/supplychain/delivery/RouteCardriver.vue')
      },
      {
        path: 'supplychain/delivery/route',
        name: 'route',
        component: () => import('../views/supplychain/delivery/Route.vue')
      },
      {
        path: 'supplychain/delivery/driver',
        name: 'driver',
        component: () => import('../views/supplychain/delivery/Driver.vue')
      },
      {
        path: 'supplychain/delivery/truck',
        name: 'truck',
        component: () => import('../views/supplychain/delivery/Truck.vue')
      },
      {
        path: 'supplychain/delivery/insurance',
        name: 'insurance',
        component: () => import('../views/supplychain/delivery/Insurance.vue')
      },
      {
        path: 'supplychain/delivery/gasline',
        name: 'gasline',
        component: () => import('../views/supplychain/delivery/Gasline.vue')
      },
      {
        path: 'supplychain/delivery/oilcard',
        name: 'oilcard',
        component: () => import('../views/supplychain/delivery/Oilcard.vue')
      },
      {
        path: 'supplychain/delivery/oilrecord',
        name: 'oilrecord',
        component: () => import('../views/supplychain/delivery/Oilrecord.vue')
      },
      {
        path: 'supplychain/delivery/limo',
        name: 'limo',
        component: () => import('../views/supplychain/delivery/Limo.vue')
      },
      {
        path: 'supplychain/delivery/maintain',
        name: 'maintain',
        component: () => import('../views/supplychain/delivery/Maintain.vue')
      },
      {
        path: 'supplychain/delivery/accdt',
        name: 'accdt',
        component: () => import('../views/supplychain/delivery/Accdt.vue')
      },
      {
        path: 'supplychain/delivery/carsets',
        name: 'carsets',
        component: () => import('../views/supplychain/delivery/Carsets.vue')
      },
      {
        path: 'supplychain/delivery/carsetck',
        name: 'carsetck',
        component: () => import('../views/supplychain/delivery/Carsetck.vue')
      },
      {
        path: 'supplychain/delivery/deliverydiff',
        name: 'deliverydiff',
        component: () => import('../views/supplychain/delivery/DeliveryDiff.vue')
      },
      {
        path: 'supplychain/source/examrep',
        name: 'examrep',
        component: () => import('../views/supplychain/source/ExamRep.vue')
      },
      {
        path: 'supplychain/source/goodstrace',
        name: 'goodstrace',
        component: () => import('../views/supplychain/source/Goodstrace.vue')
      },
      {
        path: 'supplychain/source/samplelabel',
        name: 'samplelabel',
        component: () => import('../views/supplychain/source/Samplelabel.vue')
      },
      {
        path: 'supplychain/source/carexa',
        name: 'carexa',
        component: () => import('../views/supplychain/source/Carexa.vue')
      },
      {
        path: 'supplychain/source/foodsexa',
        name: 'foodsexa',
        component: () => import('../views/supplychain/source/Foodsexa.vue')
      },
      {
        path: 'supplychain/purchase/purchasebilldetail',
        name: 'purchasebilldetail',
        component: () => import('../views/supplychain/purchase/PurchaseBillDetail.vue')
      },
      {
        path: 'supplychain/container/containerlist',
        name: 'containerlist',
        component: () => import('../views/supplychain/container/ContainerList.vue')
      },
      {
        path: 'supplychain/container/inoutrecord',
        name: 'inoutrecord',
        component: () => import('../views/supplychain/container/InoutRecord.vue')
      },
      {
        path: 'supplychain/container/custloan',
        name: 'custloan',
        component: () => import('../views/supplychain/container/CustLoan.vue')
      },
      {
        path: 'inoutstock/inmanage/buyin',
        name: 'buyin',
        component: () => import('../views/inoutstock/inmanage/BuyIn.vue')
      },
      {
        path: 'inoutstock/inmanage/goodsinspection',
        name: 'goodsinspection',
        component: () => import('../views/inoutstock/inmanage/GoodsInspection.vue')
      },
      {
        path: 'inoutstock/inmanage/custreturn',
        name: 'custreturn',
        component: () => import('../views/inoutstock/inmanage/CustReturn.vue')
      },
      {
        path: 'inoutstock/inmanage/inadjustbill',
        name: 'inadjustbill',
        component: () => import('../views/inoutstock/inmanage/InAdjustbill.vue')
      },
      {
        path: 'inoutstock/inmanage/purchasein',
        name: 'purchasein',
        component: () => import('../views/inoutstock/inmanage/PurchaseIn.vue')
      },
       {
        path: 'inoutstock/inmanage/tripartiteBuyin',
        name: 'tripartiteBuyin',
        component: () => import('../views/inoutstock/inmanage/TripartiteBuyin.vue')
      },
      {
        path: 'inoutstock/inmanage/instat',
        name: 'instat',
        component: () => import('../views/inoutstock/inmanage/Instat.vue')
      },
      {
        path: 'inoutstock/outmanage/saleout',
        name: 'saleout',
        component: () => import('../views/inoutstock/outmanage/SaleOut.vue')
      },
      {
        path: 'inoutstock/outmanage/soldout',
        name: 'soldout',
        component: () => import('../views/inoutstock/outmanage/SoldOut.vue')
      },
      {
        path: 'inoutstock/outmanage/soldoutcompany',
        name: 'soldoutcompany',
        component: () => import('../views/inoutstock/outmanage/SoldOutCompany.vue')
      },
      {
        path: 'inoutstock/outmanage/buyrefund',
        name: 'buyrefund',
        component: () => import('../views/inoutstock/outmanage/BuyRefund.vue')
      },
      {
        path: 'inoutstock/segment/segmentplan',
        name: 'segmentplan',
        component: () => import('../views/inoutstock/segment/SegmentPlan.vue')
      },
      {
        path: 'inoutstock/segment/segmentbill',
        name: 'segmentbill',
        component: () => import('../views/inoutstock/segment/SegmentBill.vue')
      },
      {
        path: 'inoutstock/segment/demand',
        name: 'segmentdemand',
        component: () => import('../views/inoutstock/segment/demand.vue')
      },
      {
        path: 'inoutstock/segment/process',
        name: 'process',
        component: () => import('../views/inoutstock/segment/Process.vue')
      },
      {
        path: 'inoutstock/segment/processbill',
        name: 'processbill',
        component: () => import('../views/inoutstock/segment/ProcessBill.vue')
      },
      {
        path: 'inoutstock/segment/calculate',
        name: 'calculate',
        component: () => import('../views/inoutstock/segment/Calculate.vue')
      },
      {
        path: 'inoutstock/stockaccount/inventory',
        name: 'inventory',
        component: () => import('../views/inoutstock/stockaccount/Inventory.vue')
      },
      {
        path: 'inoutstock/stockaccount/stocklog',
        name: 'stocklog',
        component: () => import('../views/inoutstock/stockaccount/StockLog.vue')
      },
      {
        path: 'inoutstock/stockaccount/virtualinout',
        name: 'virtualinout',
        component: () => import('../views/inoutstock/stockaccount/VirtualInout.vue')
      },
      {
        path: 'inoutstock/stockaccount/stockadjustbill',
        name: 'stockadjustbill',
        component: () => import('../views/inoutstock/stockaccount/StockAdjustBill.vue')
      },
      {
        path: 'inoutstock/stockaccount/indetail',
        name: 'indetail',
        component: () => import('../views/inoutstock/stockaccount/Indetail.vue')
      },
      {
        path: 'inoutstock/stockaccount/outdetail',
        name: 'outdetail',
        component: () => import('../views/inoutstock/stockaccount/Outdetail.vue')
      },
      {
        path: 'inoutstock/stockaccount/inoutsummary',
        name: 'inoutsummary',
        component: () => import('../views/inoutstock/stockaccount/InoutSummary.vue')
      },
      {
        path: 'inoutstock/stockaccount/stockshiftplan',
        name: 'stockshiftplan',
        component: () => import('../views/inoutstock/stockaccount/StockshiftPlan.vue')
      },
      {
        path: 'inoutstock/stockaccount/stockshiftbill',
        name: 'stockshiftbill',
        component: () => import('../views/inoutstock/stockaccount/StockshiftBill.vue')
      },
      // {
      //   path: 'inoutstock/baseinfo/producer',
      //   name: 'producer',
      //   component: () => import('../views/inoutstock/baseinfo/Producer.vue')
      // },
      {
        path: 'market/marketing/limitlockprice',
        name: 'limitlockprice',
        component: () => import('../views/market/marketing/LimitLockprice.vue')
      },
      {
        path: 'market/marketing/combinegoods',
        name: 'combinegoods',
        component: () => import('../views/market/marketing/CombineGoods.vue')
      },
      {
        path: 'finance/customer/custclear',
        name: 'custclear',
        component: () => import('../views/finance/customer/CustClear.vue')
      },
      {
        path: 'finance/customer/custclearnew',
        name: 'custclearnew',
        component: () => import('../views/finance/customer/CustClearNew.vue')
      },
      {
        path: 'finance/customer/custvouchers',
        name: 'custvouchers',
        component: () => import('../views/finance/customer/CustVouchers.vue')
      },
      {
        path: 'finance/customer/checkbill',
        name: 'checkbill',
        component: () => import('../views/finance/customer/CheckBill.vue')
      },
      {
        path: 'finance/supplier/supplierclear',
        name: 'supplierclear',
        component: () => import('../views/finance/supplier/SupplierClear.vue')
      },
      {
        path: 'finance/supplier/supplierclearnew',
        name: 'supplierclearnew',
        component: () => import('../views/finance/supplier/SupplierClearNew.vue')
      },
      {
        path: 'finance/supplier/dirsupplierclear',
        name: 'dirsupplierclear',
        component: () => import('../views/finance/supplier/DirsupplierClear.vue')
      },
      {
        path: 'finance/supplier/ledgerclear',
        name: 'ledgerclear',
        component: () => import('../views/finance/supplier/LedgerClear.vue')
      },
      {
        path: 'finance/supplier/needpaybill',
        name: 'needpaybill',
        component: () => import('../views/finance/supplier/NeedPaybill.vue')
      },
      {
        path: 'finance/supplier/advancepay',
        name: 'advancepay',
        component: () => import('../views/finance/supplier/AdvancePay.vue')
      },
      {
        path: 'finance/fsettle/settleclear',
        name: 'settleclear',
        component: () => import('../views/finance/fsettle/SettleClear.vue')
      },
      {
        path: 'finance/fsettle/scgross',
        name: 'scgross',
        component: () => import('../views/finance/fsettle/ScGross.vue')
      },
      {
        path: 'finance/performance/psort',
        name: 'psort',
        component: () => import('../views/finance/performance/Psort.vue')
      },
      {
        path: 'finance/performance/pdelivery',
        name: 'pdelivery',
        component: () => import('../views/finance/performance/Pdelivery.vue')
      },
      {
        path: 'org/staff/role',
        name: 'role',
        component: () => import('../views/org/staff/Role.vue')
      },
      {
        path: 'org/staff/stafforg',
        name: 'stafforg',
        component: () => import('../views/org/staff/StaffOrg.vue')
      },
      {
        path: 'org/staff/usercam',
        name: 'usercam',
        component: () => import('../views/org/staff/Usercam.vue')
      },
      {
        path: 'org/staff/user',
        name: 'user',
        component: () => import('../views/org/staff/User.vue')
      },
      {
        path: 'org/staff/processuser',
        name: 'processuser',
        component: () => import('../views/org/staff/ProcessUser.vue')
      },
      {
        path: 'org/staff/usermsg',
        name: 'usermsg',
        component: () => import('../views/org/staff/Usermsg.vue')
      },
      {
        path: 'org/orgnization/orgcombine',
        name: 'orgcombine',
        component: () => import('../views/org/orgnization/OrgCombine.vue')
      },
      {
        path: 'org/orgnization/orgmanage',
        name: 'orgmanage',
        component: () => import('../views/org/orgnization/Orgmanage.vue')
      },
      {
        path: 'org/orgnization/customerproduct',
        name: 'customerproduct',
        component: () => import('../views/org/orgnization/CustomerProduct.vue')
      },
      {
        path: 'org/orgnization/classmanage',
        name: 'classmanage',
        component: () => import('../views/org/orgnization/Classmanage.vue')
      },
      {
        path: 'org/orgnization/customer',
        name: 'customer',
        component: () => import('../views/org/orgnization/Customer.vue')
      },
      {
        path: 'org/orgnization/customerhm',
        name: 'customerhm',
        component: () => import('../views/org/orgnization/Customerhm.vue')
      },
      {
        path: 'org/orgnization/dinesheet',
        name: 'dinesheet',
        component: () => import('../views/org/orgnization/DineSheet.vue')
      },
      {
        path: 'org/orgnization/dinetp',
        name: 'dinetp',
        component: () => import('../views/org/orgnization/DineTp.vue')
      },
      {
        path: 'org/orgnization/educationorg',
        name: 'educationorg',
        component: () => import('../views/org/orgnization/EducationOrg.vue')
      },
      {
        path: 'org/supplieraccount/supplierlist',
        name: 'supplierlist',
        component: () => import('../views/org/supplieraccount/SupplierList.vue')
      },
      {
        path: 'org/supplieraccount/suppliermanage',
        name: 'suppliermanage',
        component: () => import('../views/org/supplieraccount/SupplierManage.vue')
      },
      {
        path: 'org/supplieraccount/firmscsupplier',
        name: 'firmscsupplier',
        component: () => import('../views/org/supplieraccount/FirmScSupplier.vue')
      },
      {
        path: 'org/producer/producermanage',
        name: 'producermanage',
        component: () => import('../views/org/producer/ProducerManage.vue')
      },
      {
        path: 'org/settle/settlement',
        name: 'settlement',
        component: () => import('../views/org/settle/Settlement.vue')
      },
      {
        path: 'system/runset/systemconfig',
        name: 'systemconfig',
        component: () => import('../views/system/runset/SysConfig.vue')
      },
      {
        path: 'system/runset/runtime',
        name: 'runtime',
        component: () => import('../views/system/runset/Runtime.vue')
      },
      {
        path: 'system/runset/workday',
        name: 'workday',
        component: () => import('../views/system/runset/Workday.vue')
      },
      {
        path: 'system/runset/workdayschool',
        name: 'workdayschool',
        component: () => import('../views/system/runset/WorkdaySchool.vue')
      },
      {
        path: 'system/runset/printtemplates',
        name: 'printtemplates',
        component: () => import('../views/system/runset/PrintTemplates.vue')
      },
      {
        path: 'system/runset/barnhouse',
        name: 'barnhouse',
        component: () => import('../views/system/runset/BarnHouse.vue')
      },
      {
        path: 'system/runset/stockconfig',
        name: 'stockconfig',
        component: () => import('../views/system/runset/StockConfig.vue')
      },
      {
        path: 'system/runset/barn',
        name: 'barn',
        component: () => import('../views/system/runset/Barn.vue')
      },
      {
        path: 'system/runset/freight',
        name: 'freight',
        component: () => import('../views/system/runset/Freight.vue')
      },
      {
        path: 'system/runset/cameraset',
        name: 'cameraset',
        component: () => import('../views/system/runset/CameraSet.vue')
      },
      {
        path: 'system/runset/device',
        name: 'device',
        component: () => import('../views/system/runset/Device.vue')
      },
      {
        path: 'system/runset/goodscam',
        name: 'goodscam',
        component: () => import('../views/system/runset/Goodscam.vue')
      },
      {
        path: 'system/devops/unpackorders',
        name: 'unpackorders',
        component: () => import('../views/system/devops/UnpackOrders.vue')
      },
      {
        path: 'system/devops/settlerate',
        name: 'settlerate',
        component: () => import('../views/system/devops/SettleRate.vue')
      },
      {
        path: 'system/devops/buyinmaintain',
        name: 'buyinmaintain',
        component: () => import('../views/system/devops/BuyinMaintain.vue')
      },
      {
        path: 'system/devops/hmai',
        name: 'hmai',
        component: () => import('../views/system/devops/Hmai.vue')
      },
      {
        path: 'system/devops/goodsdys',
        name: 'goodsdys',
        component: () => import('../views/system/devops/GoodsDys.vue')
      },
      {
        path: 'system/devops/ledgermaintain',
        name: 'ledgermaintain',
        component: () => import('../views/system/devops/LedgerMaintain.vue')
      },
      {
        path: 'system/log/oplog',
        name: 'oplog',
        component: () => import('../views/system/log/OpLog.vue')
      },
      {
        path: 'system/wxapp/banner',
        name: 'banner',
        component: () => import('../views/system/wxapp/Banner.vue')
      },
      {
        path: 'monitor/monitorset//monitororg',
        name: 'monitororg',
        component: () => import('../views/monitor/monitorset/MonitorOrg.vue')
      },
      {
        path: 'monitor/monitorset/realtime',
        name: 'realtime',
        component: () => import('../views/monitor/monitorset/RealTime.vue')
      },
      {
        path: 'monitor/monitorset/playback',
        name: 'playback',
        component: () => import('../views/monitor/monitorset/PlayBack.vue')
      },
      {
        path: 'monitor/monitorset/facialAlarmStatistics',
        name: 'facialAlarmStatistics',
        component: () => import('../views/monitor/monitorset/FacialAlarmStatistics.vue')
      },
      {
        path: 'monitor/car/carlive',
        name: 'carlive',
        component: () => import('../views/monitor/car/CarLive.vue')
      },
      {
        path: 'monitor/car/videoinspect',
        name: 'videoinspect',
        component: () => import('../views/monitor/car/VideoInspect.vue')
      },
      {
        path: 'monitor/car/routeback',
        name: 'routeback',
        component: () => import('../views/monitor/car/Routeback.vue')
      },
      {
        path: 'monitor/car/bdlive',
        name: 'bdlive',
        component: () => import('../views/monitor/car/Bdlive.vue')
      },
      {
        path: 'monitor/car/bdspect',
        name: 'bdspect',
        component: () => import('../views/monitor/car/Bdspect.vue')
      },
      {
        path: 'monitor/car/bdback',
        name: 'bdback',
        component: () => import('../views/monitor/car/Bdback.vue')
      },
      {
        path: 'superuser/dict',
        name: 'dict',
        component: () => import('../views/superuser/Dict.vue')
      },
      {
        path: 'superuser/menulist',
        name: 'menulist',
        component: () => import('../views/superuser/MenuList.vue')
      },
      {
        path: 'superuser/package',
        name: 'package',
        component: () => import('../views/superuser/Package.vue')
      },
      {
        path: 'superuser/apply',
        name: 'apply',
        component: () => import('../views/superuser/Apply.vue')
      },
      {
        path: 'superuser/group',
        name: 'group',
        component: () => import('../views/superuser/Group.vue')
      },
      {
        path: 'superuser/partcenter',
        name: 'partcenter',
        component: () => import('../views/superuser/PartCenter.vue')
      },
      {
        path: 'superuser/site',
        name: 'site',
        component: () => import('../views/superuser/Site.vue')
      },
      {
        path: 'superuser/settlepack',
        name: 'settlepack',
        component: () => import('../views/superuser/SettlePack.vue')
      },
      {
        path: 'superuser/infor',
        name: 'infor',
        component: () => import('../views/superuser/Infor.vue')
      },
      {
        path: 'aftersale/afterlist',
        name: 'afterlist',
        component: () => import('../views/aftersale/AfterList.vue')
      },
      {
        path: 'aftersale/issue',
        name: 'issue',
        component: () => import('../views/aftersale/Issue.vue')
      },
      {
        path: 'report/purin/buystat',
        name: 'buystat',
        component: () => import('../views/report/purin/Buystat.vue')
      },
      {
        path: 'report/purin/buyanalyse',
        name: 'buyanalyse',
        component: () => import('../views/report/purin/BuyAnalyse.vue')
      },
      {
        path: 'report/purin/buybillstat',
        name: 'buybillstat',
        component: () => import('../views/report/purin/Buybillstat.vue')
      },
      {
        path: 'report/purin/ledgerstat',
        name: 'ledgerstat',
        component: () => import('../views/report/purin/LedgerStat.vue')
      },
      {
        path: 'report/purin/pricetrend',
        name: 'pricetrend',
        component: () => import('../views/report/purin/PriceTrend.vue')
      },
      {
        path: 'report/purin/returnsalestat',
        name: 'returnsalestat',
        component: () => import('../views/report/purin/ReturnSaleStat.vue')
      },
      {
        path: 'report/purin/supplierdiscountstat',
        name: 'supplierdiscountstat',
        component: () => import('../views/report/purin/SupplierDiscountStat.vue')
      },
      {
        path: 'report/purin/supplieranalysis',
        name: 'supplieranalysis',
        component: () => import('../views/report/purin/SupplierAnalysis.vue')
      },
      {
        path: 'report/purin/jiuzhou',
        name: 'jiuzhou',
        component: () => import('../views/report/purin/Jiuzhou.vue')
      },
      {
        path: 'report/sale/orgstat',
        name: 'orgstat',
        component: () => import('../views/report/sale/OrgStat.vue')
      },
      {
        path: 'report/sale/goodsvol',
        name: 'goodsvol',
        component: () => import('../views/report/sale/GoodsVol.vue')
      },
      {
        path: 'report/sale/salesloss',
        name: 'salesloss',
        component: () => import('../views/report/sale/Salesloss.vue')
      },
       {
        path: 'report/sale/grossprofit',
        name: 'grossprofit',
        component: () => import('../views/report/sale/GrossProfit.vue')
      },
      {
        path: 'report/sale/orderupstat',
        name: 'orderupstat',
        component: () => import('../views/report/sale/OrderupStat.vue')
      },
      {
        path: 'report/sale/unistat',
        name: 'unistat',
        component: () => import('../views/report/sale/UniStat.vue')
      },
      {
        path: 'report/sale/dinerest',
        name: 'dinerest',
        component: () => import('../views/report/sale/DineRest.vue')
      },
      {
        path: 'report/sale/grossprofitforecast',
        name: 'grossprofitforecast',
        component: () => import('../views/report/sale/GrossProfitForecast.vue')
      },
      {
        path: 'report/sale/fyqcess',
        name: 'fyqcess',
        component: () => import('../views/report/sale/Fyqcess.vue')
      },
      {
        path: 'report/finreport/orgcheckroll',
        name: 'orgcheckroll',
        component: () => import('../views/report/finreport/OrgcheckRoll.vue')
      },
      {
        path: 'report/finreport/dinecheckdetail',
        name: 'dinecheckdetail',
        component: () => import('../views/report/finreport/DinecheckDetail.vue')
      },
      {
        path: 'report/finreport/orgcheckdetail',
        name: 'orgcheckdetail',
        component: () => import('../views/report/finreport/OrgcheckDetail.vue')
      },
      {
        path: 'report/finreport/suppliercheckdetail',
        name: 'suppliercheckdetail',
        component: () => import('../views/report/finreport/SuppliercheckDetail.vue')
      }, 
      {
        path: 'report/finreport/channelsupplier',
        name: 'channelsupplier',
        component: () => import('../views/report/finreport/Channelsupplier.vue')
      },
      {
        path: 'report/finreport/vegesupplier',
        name: 'vegesupplier',
        component: () => import('../views/report/finreport/Vegesupplier.vue')
      },
      {
        path: 'report/finreport/supplierchecksum',
        name: 'supplierchecksum',
        component: () => import('../views/report/finreport/SuppliercheckSum.vue')
      },
      {
        path: 'report/finreport/carstat',
        name: 'carstat',
        component: () => import('../views/report/finreport/CarStat.vue')
      },
      {
        path: 'report/finreport/dinelunchcheck',
        name: 'dinelunchcheck',
        component: () => import('../views/report/finreport/DinelunchCheck.vue')
      },
      {
        path: 'report/finreport/taxratestat',
        name: 'taxratestat',
        component: () => import('../views/report/finreport/TaxrateStat.vue')
      },
      {
        path: 'report/short/segmentloss',
        name: 'segmentloss',
        component: () => import('../views/report/short/SegmentLoss.vue')
      },
      {
        path: 'report/short/processloss',
        name: 'processloss',
        component: () => import('../views/report/short/ProcessLoss.vue')
      },
      {
        path: 'report/short/pickloss',
        name: 'pickloss',
        component: () => import('../views/report/short/PickLoss.vue')
      },
      {
        path: 'report/short/stockshortbill',
        name: 'stockshortbill',
        component: () => import('../views/report/short/StockShortBill.vue')
      },
      {
        path: 'report/short/aftershort',
        name: 'aftershort',
        component: () => import('../views/report/short/AfterShort.vue')
      },
      {
        path: 'report/short/goodswarning',
        name: 'goodswarning',
        component: () => import('../views/report/short/GoodsWarning.vue')
      },
      {
        path: 'report/short/lossrecord',
        name: 'lossrecord',
        component: () => import('../views/report/short/LossRecord.vue')
      },
      {
        path: 'report/short/goodswarningset',
        name: 'goodswarningset',
        component: () => import('../views/report/short/GoodsWarningSet.vue')
      },
      {
        path: 'report/storage/stockstats',
        name: 'stockstats',
        component: () => import('../views/report/storage/StockStats.vue')
      },
      {
        path: 'report/storage/expalert',
        name: 'expalert',
        component: () => import('../views/report/storage/Expalert.vue')
      },
      {
        path: 'report/client/userstatis',
        name: 'userstatis',
        component: () => import('../views/report/client/UserStatis.vue')
      },
      {
        path: 'report/client/goodsstatis',
        name: 'goodsstatis',
        component: () => import('../views/report/client/GoodsStatis.vue')
      },
      {
        path: 'report/client/deliverystatis',
        name: 'deliverystatis',
        component: () => import('../views/report/client/DeliveryStatis.vue')
      },
      {
        path: 'report/client/summarystatis',
        name: 'summarystatis',
        component: () => import('../views/report/client/SummaryStatis.vue')
      },
      {
        path: 'report/client/check',
        name: 'check',
        component: () => import('../views/report/client/Check.vue')
      },
      {
        path: 'report/client/inouttrack',
        name: 'inouttrack',
        component: () => import('../views/report/client/InOutTrack‌.vue')
      }
    ]
  }

  //{
    //配置404页面
    //path: '/:catchAll(.*)',
    //name: '404',
    //component: () => import(''),
  //}
]
// 路由
const router = createRouter({
    history: createWebHashHistory(),
    routes
})
// 导出
export default router 